<template>
  <b-modal
    :id="id"
    :title="this.$translate(title)"
    hide-footer
    size="lg"
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
    @hide="hide"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.identifier" form-group-id="identifier" placeholder="Identifier" required />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.title" form-group-id="title" placeholder="Title" required />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.subtitle" form-group-id="subtitle" placeholder="Subtitle" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.content" form-group-id="content" placeholder="Content" required />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between mt-3">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-140" @click="close">
          {{ 'Close' | i18n }}
        </b-button>
        <b-button
          variant="outline-primary"
          size="lg"
          class="btn-delete-device px-140"
          :disabled="!data.title || !data.identifier || !data.content"
          @click="onSubmit"
        >
          {{ 'Save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../common/input';
import { ListMixin, NotificationMixin } from '../../../../mixins';

export default {
  title: 'Add part',
  components: { Input },
  mixins: [NotificationMixin, ListMixin],
  props: {
    getPage: {
      type: Function,
      default: () => {}
    },
    onSave: {
      type: Function,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    listId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    initData: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      data: {
        identifier: '',
        title: '',
        subtitle: '',
        content: ''
      },
      preventCloseLocal: true
    };
  },
  methods: {
    async show() {
      this.clear();
      if (this.type === 'edit') {
        this.data = Object.assign({}, this.initData);
      }
    },
    close() {
      this.$root.$emit('bv::hide::modal', this.id);
      this.clear();
    },
    clear() {
      this.data = {
        identifier: '',
        title: '',
        subtitle: '',
        content: ''
      };
    },
    hide(e) {
      if (this.preventCloseLocal) {
        let message = confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!message) {
          e.preventDefault();
        }
        this.clear();
      }
    },
    async onSubmit() {
      try {
        this.preventCloseLocal = false;
        const d = this.data;
        const payload = {
          identifier: d.identifier,
          title: d.title,
          subtitle: d.subtitle,
          content: d.content
        };

        if (this.type === 'edit') {
          await this.listService.updateItem(this.listId, d.id, payload);
        } else {
          await this.listService.createItem(this.listId, [payload]);
        }
        await this.onSave(payload, d.id);
        this.$root.$emit('bv::hide::modal', this.id);
        await this.getPage();
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
        this.preventCloseLocal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}
.px-140 {
  padding-left: 140px;
  padding-right: 140px;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
